// Lead source data model
//
// Each lead source object: { id, name, isActive, order }
//
// Stored in companies/{id}/meta/extras.leadSources, mirroring the
// data-as-config pattern used for jobTypes / customFields / costCategories.
//
// A job records the SELECTED source by id (jobs/{id}.leadSource), not by name,
// so renaming a source later doesn't orphan historical jobs. Sources are
// SOFT-hidden (isActive:false), never hard-deleted while referenced, so a job
// that points at a source id can always resolve to a display name. Every
// industry's shipped defaults use STABLE string ids so read-time seeding (which
// can run on any client, including non-owners that can't persist) produces
// identical ids everywhere. The defaults themselves are each industry's own —
// its pack in utils/industryPacks/, read through
// buildDefaultLeadSourcesForIndustry() in utils/industryRegistry.js.

// True when a company has no lead sources yet (needs seeding/backfill).
export function leadSourcesNeedSeed(arr) {
  return !Array.isArray(arr) || arr.length === 0;
}

// Id generator for owner-added custom sources.
export function newLeadSourceId() {
  return `ls_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;
}

// Resolve a lead source id to its current display name. Returns '' when the id
// is empty or unresolvable (caller decides how to render "not recorded").
export function leadSourceNameById(sources, id) {
  if (!id) return '';
  const found = (sources || []).find(s => s && s.id === id);
  return found ? found.name : '';
}
